import styled, { keyframes } from 'styled-components'
import { pulse } from 'react-animations'

import { size_6, size_8 } from '../../module/style-variables'

const animateButton = keyframes`${pulse}`
const animateButtonAway = keyframes`${pulse}`

export const LandingPageContainer = styled.div`
  min-height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`
export const MessageContainer = styled.div`
  margin-top: ${size_8};
  margin-bottom: ${size_8};
  padding-top: ${size_8};
  padding-bottom: ${size_8};
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  justify-content: center;
  width: 100%;
`

export const ButtonContainer = styled.div`
  margin-top: ${size_8};
  padding: ${size_8};
  width: 100%;
  animation: ${props => (props.going ? `0.4s ${animateButtonAway}` : `0.8s ${animateButton}`)};
`
export const CompanyStrapLineImg = styled.img`
  padding-top: ${size_6};
  max-width: 160px;
`



// WEBPACK FOOTER //
// ./src/component/LandingPage/LandingPage-styled.js